import moment from "moment-timezone";

export interface ShippedReportPreset {
  id: string;
  label: string;
  customer_long_names: string[];
  commodity_id?: string;
  ship_to_long_name?: string;
  ship_date_start?: string;
  ship_date_end?: string;
  title?: string;
  tab_name?: string;
}

export const SHIPPED_REPORT_PRESETS: ShippedReportPreset[] = [
  {
    id: "gevo-yearly-report",
    label: "Gevo",
    customer_long_names: [],
    commodity_id: "",
    ship_to_long_name: "Net-Zero Richardton LLC",
    ship_date_start: moment().startOf("year").format("YYYY-MM-DD"),
    ship_date_end: moment().endOf("year").format("YYYY-MM-DD"),
    title: `Calendar Year ${moment().year()} Net-Zero`,
    tab_name: `${moment().year()} Net Zero`,
  },
];
